import script from "./OffersDayView.vue?vue&type=script&setup=true&lang=js"
export * from "./OffersDayView.vue?vue&type=script&setup=true&lang=js"

import "./OffersDayView.vue?vue&type=style&index=0&id=94faecb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94faecb6"]])

export default __exports__